export const getFilterSliders = (vals, set) => [
  {
    label: "Grayscale",
    min: 0,
    max: 100,
    value: vals.greyscale,
    unit: "%",
    onChange: set("greyscale"),
  },
  {
    label: "Blur",
    min: 0,
    max: 30,
    value: vals.blur,
    unit: "px",
    onChange: set("blur"),
  },
  {
    label: "Sepia",
    min: 0,
    max: 100,
    value: vals.sepia,
    unit: "%",
    onChange: set("sepia"),
  },
  {
    label: "Saturate",
    min: 0,
    max: 300,
    value: vals.saturate,
    unit: "%",
    onChange: set("saturate"),
  },
  {
    label: "Opacity",
    min: 0,
    max: 100,
    value: vals.opacity,
    unit: "%",
    onChange: set("opacity"),
  },
  {
    label: "Brightness",
    min: 0,
    max: 200,
    value: vals.brightness,
    unit: "%",
    onChange: set("brightness"),
  },
  {
    label: "Contrast",
    min: 0,
    max: 200,
    value: vals.contrast,
    unit: "%",
    onChange: set("contrast"),
  },
  {
    label: "Hue Rotate",
    min: 0,
    max: 360,
    value: vals.hue,
    unit: "°",
    onChange: set("hue"),
  },
  {
    label: "Invert",
    min: 0,
    max: 100,
    value: vals.invert,
    unit: "%",
    onChange: set("invert"),
  },
];
